import { Tab, TabList, TabPanel, TabPanels, Tabs } from '@ritualco/jutsu'
import { FullWidthPage } from 'components/PageTemplates'
import { useContent } from 'lib/content/react'
import { useTabControl } from 'hooks/useTabControl'
import MyLists from './MyLists'
import MyNetwork from './MyNetwork'

type MerchantListsProps = {
  organizationId: string
  workspaceId: string
  tabPaths: string[]
}

const MerchantLists = ({
  organizationId,
  workspaceId,
  tabPaths,
}: MerchantListsProps) => {
  const { formatMessage } = useContent()
  const [tabIndex, handleTabChange] = useTabControl(tabPaths)

  return (
    <FullWidthPage
      heading={formatMessage({ id: 'pmportal.restaurantLists.title' })}
      showDivider={false}
    >
      <Tabs variant="line" index={tabIndex} onChange={handleTabChange}>
        <TabList>
          <Tab>
            {formatMessage({ id: 'pmportal.restaurantLists.networkTitle' })}
          </Tab>
          <Tab>
            {formatMessage({ id: 'pmportal.restaurantLists.listsTitle' })}
          </Tab>
        </TabList>
        <TabPanels>
          <TabPanel>
            <MyNetwork
              workspaceId={workspaceId}
              organizationId={organizationId}
            />
          </TabPanel>
          <TabPanel>
            <MyLists
              workspaceId={workspaceId}
              organizationId={organizationId}
            />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </FullWidthPage>
  )
}

export default MerchantLists
